<template>
  <v-layout justify-space-between align-center>
    <v-layout justify-start align-center>
      <span v-for="item in items" :key="item.title">
        <router-link
          v-if="item.enable"
          :to="item.route"
          :class="{
            'text--primary': item.active,
            'text--secondary': !item.active
          }"
          class="headline font-weight-medium pr-md-5 pl-md-0 pr-4 pl-2"
          role="button"
        >
          {{ item.title }}
        </router-link>
      </span>
    </v-layout>
    <button
      v-if="visibleSaveTempBtn"
      @click="addTemplate"
      class="subtitle-1 font-weight-medium"
    >
      <icon-check :color="$vuetify.theme.primary"></icon-check>
      <span class="ml-2 valign-bottom">Сохранить как шаблон</span>
    </button>
  </v-layout>
</template>

<script>
import IconCheck from "../icon/IconCheck.vue";

export default {
  name: "NavigationStatistic",

  components: { IconCheck },

  data: () => ({}),

  computed: {
    // видимость кнопки сохранения
    visibleSaveTempBtn() {
      return this.$route.name === "statisticsTemplates" &&
        this.$store.getters.templateList.length === 0
        ? false
        : true;
    },
    // объект с основным меню
    items() {
      let list = [
        {
          title: "Общая статистика",
          route: { name: "statisticsGeneral" },
          active: this.$route.name === "statisticsGeneral",
          enable: true
        },
        {
          title: "Частота посещений",
          route: { name: "statisticsVisits" },
          active: this.$route.name === "statisticsVisits",
          enable: true
        },
        {
          title: "Ушедшие клиенты",
          route: { name: "statisticsGone" },
          active: this.$route.name === "statisticsGone",
          enable: true
        },
        {
          title: "Мои шаблоны",
          route: { name: "statisticsTemplates" },
          active: this.$route.name === "statisticsTemplates",
          enable: true
        },
        {
          title: "Отчет по рекламным кампаниям",
          route: { name: "" },
          active: this.$route.name === "",
          enable: false
        }
      ];

      return list;
    }
  },
  methods: {
    // для сохранения текущей статистики в шаблон
    addTemplate() {
      this.$emit("createTemplate");
    }
  }
};
</script>
